import { render, staticRenderFns } from "./perfil-ocupantes.vue?vue&type=template&id=db145276&"
import script from "./perfil-ocupantes.vue?vue&type=script&lang=js&"
export * from "./perfil-ocupantes.vue?vue&type=script&lang=js&"
import style0 from "./perfil-ocupantes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports